import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const BANDS = [
  { id: "funnel-target", label: "Target Market", note: "everyone who could use you", width: "100%", cls: "bg-brand-teal text-white" },
  { id: "funnel-prospect", label: "Prospect", note: "they feel the drag", width: "84%", cls: "bg-brand-navysurf text-white" },
  { id: "funnel-lead", label: "Lead", note: "they ask: show me where I can simplify", width: "68%", cls: "bg-brand-pale text-brand-navy" },
  { id: "funnel-client", label: "Client", note: "one process flows; the hours come back", width: "52%", cls: "bg-brand-gold text-brand-navy" },
  { id: "funnel-ambassador", label: "Ambassador", note: "they tell the next owner", width: "38%", cls: "bg-brand-green text-white" },
];

export default function FunnelSection() {
  return (
    <section className="py-20 lg:py-32 bg-white border-y border-slate-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-12 gap-8 lg:gap-12 mb-14">
          <Reveal className="col-span-12 lg:col-span-6">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-teal font-semibold mb-4">
              The path we design for
            </p>
            <h2 className="font-display font-semibold tracking-tight leading-[1.12] text-brand-navy text-2xl sm:text-3xl lg:text-4xl">
              From stranger to ambassador.
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="col-span-12 lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-base text-slate-600 leading-relaxed">
              Most firms market to the top of this funnel. We build for the
              bottom — because a client with their Fridays back becomes your
              best salesperson.
            </p>
          </Reveal>
        </div>

        <div data-testid="funnel-visual" className="max-w-3xl space-y-3">
          {BANDS.map((band, i) => (
            <motion.div
              key={band.id}
              data-testid={band.id}
              initial={{ scaleX: 0, opacity: 0 }}
              whileInView={{ scaleX: 1, opacity: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              style={{ width: band.width, transformOrigin: "left" }}
              className={`rounded-xl px-6 py-4 sm:py-5 flex items-baseline gap-4 ${band.cls}`}
            >
              <span className="font-display font-bold text-base sm:text-lg whitespace-nowrap">
                {band.label}
              </span>
              <span className="hidden sm:block text-xs opacity-80 truncate">
                {band.note}
              </span>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 text-sm text-slate-500 max-w-xl leading-relaxed">
            Every page of this site, every trial, and every measured report
            exists to move one more business from the top band to the bottom
            one.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
